var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ul-btn-icon",attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":_vm.click}},[_c('i',{class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }